import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
	id: '',
	image: '',
	userName: '',
	name: '',
	surname: '',
	email: '',
	pin: '',
	role: 'user',
	authority: []
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
		setUser: (state, action) => {
			state.id = action.payload.id
			state.image = action.payload.image
			state.userName = action.payload.userName
			state.name = action.payload.name
			state.surname = action.payload.surname
			state.email = action.payload.email
			state.pin = action.payload.pin
			state.role = action.payload.role
			state.authority = action.payload.authority
		},
        userLoggedOut: () => initialState,
	},
})

export const { setUser } = userSlice.actions

export default userSlice.reducer
